import { Form } from './Form'/* tslint:disable */
import { PublishedForm } from "./PublishedForm"
import { Step } from "./Step"
import { Text } from "./Text"

export class RootForm extends Form {
		ExternalIdsInternal: string;
		Guid: string;
		Organisation: string;
		DataType: string;
		FormState: string;
		ShowSummary: boolean;
		Id: number;
		Name: string;
		Description: string;

		PublishedForms: PublishedForm[];
		Steps: Step[];
		Texts: Text[];
}




// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/RootForm.ts